export type ButtonVariant = "primary" | "teal" | "light" | "outline" | "outline-light";
export type ButtonSize = "md" | "lg";

const BASE =
  "group/btn relative inline-flex items-center justify-center gap-2.5 rounded-full font-semibold tracking-[-0.005em] transition-[background-color,color,box-shadow,border-color,translate,scale] duration-300 ease-[var(--ease-out-expo)] motion-safe:hover:-translate-y-0.5 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-60";

const VARIANTS: Record<ButtonVariant, string> = {
  primary:
    "bg-brand-primary text-white shadow-[0_10px_30px_-12px_rgb(26_60_94/0.6)] hover:bg-navy-deep hover:shadow-[0_16px_36px_-14px_rgb(26_60_94/0.7)]",
  teal: "bg-brand-secondary text-brand-primary shadow-[0_10px_30px_-14px_rgb(114_181_177/0.8)] hover:bg-teal-light",
  light: "bg-white text-brand-primary shadow-[0_10px_30px_-14px_rgb(0_0_0/0.35)] hover:bg-teal-soft",
  outline:
    "border border-brand-primary/25 bg-white/70 text-brand-primary hover:border-brand-primary/60 hover:bg-white",
  "outline-light": "border border-white/35 text-white hover:border-white/70 hover:bg-white/10",
};

const SIZES: Record<ButtonSize, string> = {
  md: "min-h-11 px-5 text-sm",
  lg: "min-h-13 px-7 text-base",
};

export function buttonClass(variant: ButtonVariant = "primary", size: ButtonSize = "lg", extra = "") {
  return `${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${extra}`;
}
